import angular from 'angular';
import { last } from 'lodash';

module.exports = angular.module('common.filters.readable-list', [])
.filter('readableList', () => {
  return (list) => {
    switch ((list || []).length) {
      case 0:
        return '';
      case 1:
        return String(list[0]);
      case 2:
        return list.join(' and ');
      default:
        return `${list.slice(0, -1).join(', ')}, and ${last(list)}`;
    }
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/readable-list.js
 **/